export function definePricePreferencesProvider(options) {
    const { initialPriceType, initialShowPrices } = options;
    let priceType = initialPriceType;
    let showPrices = initialShowPrices;
    const listeners = new Set();
    const notifyListeners = () => {
        for (const listener of listeners) {
            listener();
        }
    };
    return {
        id: `price-preferences-provider`,
        create: () => {
            return {
                '1.0.0': () => ({
                    featureService: {
                        getPriceType: () => priceType,
                        setPriceType: (newPriceType) => {
                            if (priceType !== newPriceType) {
                                priceType = newPriceType;
                                notifyListeners();
                            }
                        },
                        getShowPrices: () => showPrices,
                        setShowPrices: (newShowPrices) => {
                            if (showPrices !== newShowPrices) {
                                showPrices = newShowPrices;
                                notifyListeners();
                            }
                        },
                        subscribe: (listener, listenerOptions) => {
                            listeners.add(listener);
                            const unsubscribe = () => listeners.delete(listener);
                            listenerOptions === null || listenerOptions === void 0 ? void 0 : listenerOptions.signal.addEventListener(`abort`, unsubscribe);
                            return unsubscribe;
                        },
                    },
                }),
            };
        },
    };
}
//# sourceMappingURL=index.js.map